import { cn } from 'noddi-ui-common';
import { MARKER_BLUE, MARKER_RED, MARKER_SVG_PATH } from './constants';

export const MapMarkerIcon = ({ red, className }: { red?: boolean; className?: string }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 384 512'
    className={cn('size-4', className)}
    aria-hidden='true'
    focusable='false'
  >
    <path d={MARKER_SVG_PATH} fill={red ? MARKER_RED : MARKER_BLUE} />
  </svg>
);
